import config from '../config.json';
import axios from 'axios';

const api = axios.create({
    baseURL: config.plugin.url,
    headers: { 'X-API-VERSION': config.xola.apiVersion },
});

export default api;
